import * as React from "react";
import type { EmptyStateProps } from "../types";
import defaultStyles from "./index.module.css";
import ExclamationTriangle from "../icons/ExclamationTriangle";
import InfoIcon from "../icons/InfoIcon";

function EmptyState(props: EmptyStateProps) {
  function classes() {
    return {
      container:
        defaultStyles.container +
        (props.className ? ` ${props.className}` : ""),
    };
  }

  function variantValue() {
    return props.variant || "info";
  }

  return (
    <div className={classes().container}>
      {variantValue() === "info" ? (
        <InfoIcon
          svgAttrs={{
            class: defaultStyles.svg,
          }}
        />
      ) : (
        <>
          <ExclamationTriangle
            svgAttrs={{
              class: defaultStyles.svg,
            }}
          />
        </>
      )}
      <h4>{props.title}</h4>
      {props.description ? (
        <p className={defaultStyles.description}>{props.description}</p>
      ) : null}
    </div>
  );
}

export default EmptyState;
